export default __webpack_public_path__ + "static/media/image40.fde71c1a.png";